module.exports = __webpack_public_path__ + "static/media/melodin.f0cb1b65.png";